export default {
  buttonTitle: {
    en: 'Got it',
  },
  text: {
    en: `
    Sorry, it looks like you already updated to PayPal.
    If you haven't and still get this message, please contact support at
  `,
  },
}
